<!-- 视频 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <div v-if="name_id == 1">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">视频上传</div>
                        <FormItem label="视频高度">
                            <Input
                                v-model="newFormData.content.height"
                                placeholder="请输入视频高度"
                            >
                                <span slot="append">PX</span>
                            </Input>
                        </FormItem>
                        <FormItem label="视频"></FormItem>
                        <div class="video-div">
                            <div class="banner-box mb0" @click="openModal(5)">
                                <Icon
                                    class="absolute-icon"
                                    type="md-add"
                                    size="44"
                                    color="#C0C4CC"
                                />
                                <video
                                    :src="newFormData.content.videoList.picview"
                                ></video>
                                <img
                                    class="del-style"
                                    src="@/assets/del.png"
                                    @click.stop="delVideo(newFormData.content)"
                                />
                            </div>
                        </div>
                        <div class="form-title mt24">播放设置</div>
                        <FormItem label="播放方式">
                            <RadioGroup v-model="newFormData.content.autoplay">
                                <Radio label="1">自动播放</Radio>
                                <Radio label="2">手动播放</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="循环播放">
                            <i-switch
                                v-model="newFormData.content.loop"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeLoop"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="下圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.bottom"
                            ></Slider
                        ></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "video",
            switch_modal: false,
            name_id: "1",
        };
    },
    mounted() {},
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.videoList.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.videoList.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal() {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        // 删除视频
        delVideo(item) {
            item.videoList.picview =
                "https://qiniu-web-assets.dcloud.net.cn/unidoc/zh/2minute-demo.mp4";
        },
        changeLoop(e) {
            this.newFormData.content.loop = e;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.banner-box {
    margin: 12px 0;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    position: relative;
    border: 1px solid #c0c4cc;
}
.banner-box video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.del-style {
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 99;
    width: 26px !important;
    height: 26px !important;
    cursor: pointer;
}
.absolute-icon {
    position: absolute;
    font-size: 50px;
    cursor: pointer;
    color: #c0c4cc;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
}
.video-div {
    padding: 12px;
    margin: 0 0 12px 0;
    border: 1px solid #c0c4cc;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
</style>